import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContextSystem } from '@wp-g2/context';
import { css, cx, useResponsiveValue } from '@wp-g2/styles';
import { useMemo } from 'react';
import { getAlignmentProps } from './Grid.utils';
/**
 * @param {import('@wp-g2/create-styles').ViewOwnProps<import('./types').Props, 'div'>} props
 */

export function useGrid(props) {
  var _useContextSystem = useContextSystem(props, 'Grid'),
      align = _useContextSystem.align,
      alignment = _useContextSystem.alignment,
      className = _useContextSystem.className,
      columnGap = _useContextSystem.columnGap,
      _useContextSystem$col = _useContextSystem.columns,
      columns = _useContextSystem$col === void 0 ? 2 : _useContextSystem$col,
      _useContextSystem$gap = _useContextSystem.gap,
      gap = _useContextSystem$gap === void 0 ? 3 : _useContextSystem$gap,
      _useContextSystem$isI = _useContextSystem.isInline,
      isInline = _useContextSystem$isI === void 0 ? false : _useContextSystem$isI,
      justify = _useContextSystem.justify,
      rowGap = _useContextSystem.rowGap,
      rows = _useContextSystem.rows,
      templateColumns = _useContextSystem.templateColumns,
      templateRows = _useContextSystem.templateRows,
      otherProps = _objectWithoutProperties(_useContextSystem, ["align", "alignment", "className", "columnGap", "columns", "gap", "isInline", "justify", "rowGap", "rows", "templateColumns", "templateRows"]);

  var column = useResponsiveValue(columns);
  var row = useResponsiveValue(rows);
  var gridTemplateColumns = templateColumns || !!columns && "repeat(" + column + ", 1fr)";
  var gridTemplateRows = templateRows || !!rows && "repeat(" + row + ", 1fr)";
  var classes = useMemo(function () {
    var alignmentProps = getAlignmentProps(alignment);
    var classes = css(_objectSpread({
      alignItems: align,
      display: isInline ? 'inline-grid' : 'grid',
      gap: gap,
      gridTemplateColumns: gridTemplateColumns,
      gridTemplateRows: gridTemplateRows,
      gridRowGap: rowGap,
      gridColumnGap: columnGap,
      justifyContent: justify,
      verticalAlign: isInline ? 'middle' : null
    }, alignmentProps));
    return cx(classes, className);
  }, [align, alignment, className, columnGap, gap, gridTemplateColumns, gridTemplateRows, isInline, justify, rowGap]);
  return _objectSpread(_objectSpread({}, otherProps), {}, {
    className: classes
  });
}